import { NotificationTypes } from './types';

interface NotificationProps {
  read?: number;
  id?: number;
  per_page?: number;
}

export const setAsRead = (id: NotificationProps) => ({
  types: [NotificationTypes.SHOW_REQUEST],
  promise: (client: any) => client.patch(`/notification/notifications/${id}`),
});

export const getAllNotifications = (params: NotificationProps) => ({
  types: [
    NotificationTypes.SHOW_REQUEST,
    NotificationTypes.SHOW_SUCCESS,
    NotificationTypes.SHOW_FAILURE,
  ],
  promise: (client: any) => client.get('/notification/notifications.json', { params }),
});

export const markAsReadNotification = (params: Object) => ({
  types: [
    NotificationTypes.MARK_AS_READ_REQUEST,
    NotificationTypes.MARK_AS_READ_SUCCESS,
    NotificationTypes.MARK_AS_READ_FAILURE,
  ],
  promise: (client: any) =>
    client.patch('/notification/atualiza_todas_como_lidas_new', {
      notification_type: params,
    }),
});
